import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'coverTextPositionLabel',
})
export class CoverTextPositionLabelPipe implements PipeTransform {
  transform(contentPosition: [number, number]) {
    const map = {
      '0.5,0.5': 'Centered',
      '0.5,0': 'Top',
      '0.5,1': 'Bottom',
      '0,0.5': 'Left',
      '1,0.5': 'Right',
      '0,0': 'Top Left',
      '1,0': 'Top Right',
      '0,1': 'Bottom Left',
      '1,1': 'Bottom Right',
    };

    return map[contentPosition.join ? contentPosition.join(',') : contentPosition.toString()];
  }
}
